import React, { useContext, useMemo, useState } from 'react';

const HOME_SUBMISSION_BANNER_SESSION_KEY =
  'home.hasAcknowledgedDesktopOnlySubmission';

interface HomeSessionContextType {
  hasAcknowledgedDesktopOnlySubmission: boolean;
  setHasAcknowledgedDesktopOnlySubmission: (acknowledged: boolean) => void;
}

const HomeSessionContext = React.createContext<HomeSessionContextType>({
  hasAcknowledgedDesktopOnlySubmission: false,
  setHasAcknowledgedDesktopOnlySubmission: () => {},
});

interface HomeSessionProviderProps {
  children: React.ReactNode;
}

function getInitialAcknowledgedDesktopOnlySubmissionState() {
  if (typeof window === 'undefined') {
    return false;
  }

  return sessionStorage.getItem(HOME_SUBMISSION_BANNER_SESSION_KEY) === 'true';
}

export function HomeSessionProvider({ children }: HomeSessionProviderProps) {
  const [
    hasAcknowledgedDesktopOnlySubmission,
    setHasAcknowledgedDesktopOnlySubmissionState,
  ] = useState<boolean>(getInitialAcknowledgedDesktopOnlySubmissionState);

  const setHasAcknowledgedDesktopOnlySubmission = (acknowledged: boolean) => {
    setHasAcknowledgedDesktopOnlySubmissionState(acknowledged);

    if (typeof window !== 'undefined') {
      sessionStorage.setItem(
        HOME_SUBMISSION_BANNER_SESSION_KEY,
        String(acknowledged),
      );
    }
  };

  const value = useMemo(
    () => ({
      hasAcknowledgedDesktopOnlySubmission,
      setHasAcknowledgedDesktopOnlySubmission,
    }),
    [hasAcknowledgedDesktopOnlySubmission],
  );

  return (
    <HomeSessionContext.Provider value={value}>
      {children}
    </HomeSessionContext.Provider>
  );
}

export const useHomeSessionContext = () => useContext(HomeSessionContext);
